import React, { useEffect, useState } from 'react';
import Layout from '@/Layout';
import { connect, useDispatch } from "react-redux";
import { message, Modal, Spin } from "antd";
import Router from "next/router";
import HostConfig from '../../actions/Host.config';
import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { setSmarticoErrorModalAction } from "$STORE/thunk/gameThunk";
import { translate } from "$ACTIONS/Translate";
import { getSmarticoToggleAction } from '../../store/thunk/gameThunk';

const _smartico_label_key = !HostConfig.Config.IsLIVE ? 'f431c8e7-f95b-447c-b02c-d1c74e91a50c-5' : "6ad0eca6-51c2-4e71-bdb2-f85a3b33088d-5";
const _smartico_brand_key = !HostConfig.Config.IsLIVE ? '1fad10fb' : "e620af5f";

const SmarticoPage = ({ errorModalToggle, game, smarticoDomain }) => {
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        if (game.smarticoErrModalVisible) {
            global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("reward_centre_maintenance_popup", "Reward Centre Maintenance Popup")
            errorModal();
        }
    }, [game.smarticoErrModalVisible]);
    
    useEffect(() => {
        const isLoginMember = JSON.parse(localStorage.getItem('access_token')) || null; // 從 localStorage 獲取 access_token 判斷用戶是否已登錄
        global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("reward_centre", "Reward Centre");
        if (!isLoginMember) {
            // 如果用戶未登錄，顯示錯誤信息並跳轉到登錄頁面
            message.error("请先登入");
            Router.push("/");
            return;
        }


        get(ApiPort.GETMemberlistAPI)
            .then((res) => {
                localStorage.setItem(
                    "memberCode",
                    res.result.memberInfo.memberCode
                );

        const storedMemberCode = localStorage.getItem("memberCode") || null; // 從 localStorage 獲取 memberCode
        if (!storedMemberCode) {
            // 如果未找到 memberCode，處理錯誤
            errorModalToggle(true);
            return;
        }
        
        // 設置全局 smartico 用戶 ID 和語言給Smartico
        window._smartico_user_id = storedMemberCode;
        window._smartico_language = 'vi';

        if (!window._smartico) {
            loadSmarticoScript(() => {
                if(!window.listenersRegistered) {
                    registerEventListeners();
                    // 避免重複監聽
                    window.listenersRegistered = true;
                }
                initializeSmartico();
            });
        } else {
            if(!window.listenersRegistered) {
                registerEventListeners();
                window.listenersRegistered = true;
            }
            showSmarticoWidget();
        }
        }); // end of .then

        return () => {
            // 組件卸載時清除全局 smartico 用戶 ID 和語言
            window._smartico_user_id = null;
            window._smartico_language = null;
            fnSetLockHeader(0); // see ./pages/vn/Games/OpenGame.js
        };
    }, []);

    const loadSmarticoScript = async (callback) => {
        console.log('loadSmarticoScript', smarticoDomain);
        let url = smarticoDomain
        if (!HostConfig.Config.IsLIVE) {
            window._smartico_allow_localhost = true; // 測試環境允許 localhost
        }

        const script = document.createElement('script');
        if(!url) {
            let res = await dispatch(getSmarticoToggleAction());
            console.log('getSmarticoToggleAction', res);
            url = res?.result?.smarticoDomain
        }

        const isJsFile =
            typeof "".endsWith === "function"
                ? url.endsWith(".js")
                : /\.js$/i.test(url);
        
        script.src = isJsFile ? url : `${url}/smartico.js`; // smartico 腳本地址
        script.id = 'smartico-script';
        script.onload = callback; // 腳本加載完成後執行 callback
        document.head.appendChild(script); // 將腳本添加到頁面
    };

    const initializeSmartico = () => {
        // 初始化 smartico
        window._smartico.on("init", (errCode) => {
            console.log('init errCode', errCode);
            if (errCode === 0) {
                showSmarticoWidget(); // 初始化成功，顯示小工具
            } else {
                errorModalToggle(true);
            }
        });
        window._smartico.init(_smartico_label_key, { brand_key: _smartico_brand_key });
    };

    const showSmarticoWidget = () => {
        // 顯示 smartico
        window._smartico.showWidget('achievements', {
            iframe: 'smartico-iframe',
            inline: true,
            height: 'auto'
        });
        let IframeDom = document.getElementById("smartico-iframe");
        if (IframeDom) {
            if (IframeDom.attachEvent) {
                IframeDom.attachEvent("onload", function () {
                    setIsLoading(false);
                });
            } else {
                IframeDom.onload = function () {
                    setIsLoading(false);
                };
            }
        } else {
            setIsLoading(false);
        }
    };

    const registerEventListeners = () => {
        const events = [
            { name: 'identify', handler: (errCode, props) => {
                    console.log('identify errCode', errCode)
                    if (errCode !== 0) {
                        errorModalToggle(true);
                    }
                }
            },
            { name: 'gf_closing', handler: () => { Router.push('/'); console.log('gf_closing '); } },

            // { name: 'props_change', handler: (props) => console.log('props ', props) },
            // { name: 'login', handler: (errCode) => console.log('login errCode ', errCode) },
            // { name: 'logout', handler: () => console.log('logout ') },
            // { name: 'gf_starting', handler: () => console.log('gf_starting ') },
        ];

        events.forEach(event => window._smartico.on(event.name, event.handler));
    };
    
    const errorModal = () => {
        // 顯示錯誤模態框
        Modal.info({
            title: "",
            centered: true,
            okText: "Đã Hiểu",
            icon: <div />,
            maskClosable: false,
            onOk: () => {
                Router.push('/');  errorModalToggle(false);
            },
            content: (
                <>
                    <img src={"/vn/img/icons/icon-warn_yellow.png"} alt="Warning" />
                    <div style={{ fontSize: 14, color: "#222",  marginTop: 16 }}>
                        Dịch vụ đang tạm thời bị gián đoạn, vui lòng thử lại sau.
                    </div>
                </>
            ),
        });
    };

    let fnSetLockHeader = function() {};
    return (
        <Layout status={1} headerHeightLock={1}
                setLockHeader={(setLockHeader) => { // see ./pages/vn/Games/OpenGame.js
                    fnSetLockHeader = setLockHeader;
                    setLockHeader(1);
                }}
        >
            <Spin spinning={isLoading} tip={translate("加载中")}>
                <div className="common-distance-wrap" style={{ position: "relative", textAlign: "center" }}>
                    <iframe
                        id="smartico-iframe"
                        align="center"
                        style={{
                            maxWidth: "initial",
                            width: "90%",
                            margin: "0 auto",
                            height: 800,
                        }}
                        frameBorder="0"
                    />
                </div>
            </Spin>
        </Layout>
    );
};

const mapStateToProps = (state) => ({
    smarticoErrorModalVisible: state.game.smarticoErrModalVisible,
    game: state.game,
    smarticoDomain: state.game.smarticoDomain,
});

const mapDispatchToProps = function (dispatch) {
    return {
        errorModalToggle: (flag) => {
            dispatch(setSmarticoErrorModalAction(flag));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SmarticoPage);